import NewExpensePage from "@/components/screens/expense/new";

export default function NewExpense() {
  return <NewExpensePage />;
}
